import React from 'react';
import LegalLayout from './LegalLayout';

const SECTIONS = [
  {
    title: '1. Aceitacao dos termos',
    content: 'Ao contratar ou utilizar o LibbenIncorp, voce concorda com estes Termos de Uso. O LibbenIncorp e uma plataforma SaaS de gestao para incorporadoras imobiliarias. Se voce nao concorda com algum ponto, nao utilize o servico.'
  },
  {
    title: '2. Descricao do servico',
    content: 'O LibbenIncorp oferece modulos de gestao de empreendimentos e unidades, financeiro por empreendimento, acompanhamento de obra, CRM de vendas, portal do cliente e dashboard executivo, acessados pela internet. O escopo exato depende do plano contratado.'
  },
  {
    title: '3. Cadastro e conta',
    content: 'O acesso exige cadastro de uma incorporadora (tenant) e de usuarios com perfis definidos. Voce e responsavel por manter a confidencialidade das credenciais e por todas as atividades realizadas na sua conta. Notifique-nos imediatamente em caso de uso nao autorizado.'
  },
  {
    title: '4. Planos e pagamento',
    content: 'Os planos sao cobrados conforme a contratacao vigente, pelo numero de empreendimentos ativos e demais limites aplicaveis. Valores, limites e condicoes podem ser revistos mediante comunicacao previa. Valores divulgados no site sao de referencia e podem variar conforme proposta comercial.'
  },
  {
    title: '5. Responsabilidades do cliente',
    content: 'Voce e responsavel pela veracidade e legalidade dos dados inseridos, incluindo informacoes financeiras, de obra, de vendas e de clientes. O LibbenIncorp e uma ferramenta de apoio a gestao e nao substitui a assessoria contabil, juridica ou de engenharia da incorporadora.'
  },
  {
    title: '6. Disponibilidade',
    content: 'Empenhamo-nos para manter o servico disponivel de forma continua, mas podem ocorrer interrupcoes para manutencao ou por fatores fora do nosso controle. Metas de nivel de servico (SLA), quando aplicaveis, sao definidas no plano contratado.'
  },
  {
    title: '7. Propriedade intelectual',
    content: 'O software, a marca LibbenIncorp e todo o conteudo da plataforma sao protegidos por direitos de propriedade intelectual. Os dados inseridos pela incorporadora permanecem de sua propriedade.'
  },
  {
    title: '8. Encerramento',
    content: 'Voce pode encerrar a contratacao conforme as condicoes do plano. Em caso de encerramento, disponibilizamos a exportacao dos seus dados por um periodo razoavel antes da exclusao definitiva.'
  },
  {
    title: '9. Alteracoes nos termos',
    content: 'Estes termos podem ser atualizados. Alteracoes relevantes serao comunicadas pelos canais de contato cadastrados. O uso continuado apos a atualizacao implica concordancia.'
  }
];

export default function Terms() {
  return (
    <LegalLayout
      title="Termos de Uso"
      canonical="https://www.libbenincorp.com/termos"
      metaDescription="Termos de Uso do LibbenIncorp, plataforma de gestao para incorporadoras."
      updatedAt="15 de outubro de 2026"
      sections={SECTIONS}
    />
  );
}
